import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';
import {Alert, Button, Checkbox, Col, Form, Input} from 'antd';
import {ApartmentOutlined, LockOutlined, UserOutlined} from '@ant-design/icons';

import './login.scss';
import {login} from '@apis/admin';
import {getTokenHeader, setTokenHeader} from "../../../utils/api";
import {PAGE} from "../../../utils/constants";

function AdminLoginPage() {
    let history = useHistory();
    const [state, setState] = useState({
        isErr: false,
        errMsg: ''
    })

    const {isErr, errMsg} = state;

    const onFinish = async (value) => {
        const { comId, username, password, remember } = value;
        const { userToken } = getTokenHeader()
        try {
            let res = await login(comId, username, password, remember);
            if (res.error) {
                throw new Error(`${res.error.msgCode} - ${res.error.message}`);
            } else {
                setTokenHeader(res.token, userToken)
                history.push(PAGE.ADMIN_PROGRAM_LIST);
            }
        } catch (e) {
            setTokenHeader('', userToken)
            setState({...state, isErr: true, errMsg: '登入名稱或密碼不正確。'})
        }
    };

    const onFinishFailed = errorInfo => {
        // console.log('Failed:', errorInfo);
    };

    return (
        <div className='admin-login-page fit-height'>
            <Col>
                <div className='login-form-container'>
                    {
                        isErr && (
                            <Alert className='err-msg' message={errMsg} type='error' showIcon />
                        )
                    }
                    <Form
                        layout='vertical'
                        labelAlign='left'
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        hideRequiredMark={true}
                        >
                        <Form.Item
                            name="comId"
                            rules={[{ required: true, message: '請填寫機構號碼' }]}
                        >
                            <Input
                                prefix={<ApartmentOutlined className="site-form-item-icon" />}
                                placeholder="機構號碼"
                            />
                        </Form.Item>
                        <Form.Item
                            name="username"
                            rules={[{ required: true, message: '請填寫登入名稱' }]}
                        >
                            <Input
                                prefix={<UserOutlined className="site-form-item-icon" />}
                                placeholder="登入名稱"
                            />
                        </Form.Item>

                        <Form.Item
                            name="password"
                            rules={[{ required: true, message: '請填寫登入密碼' }]}
                        >
                            <Input
                                prefix={<LockOutlined className="site-form-item-icon" />}
                                type="password"
                                placeholder="登入密碼"
                            />
                        </Form.Item>

                        <Form.Item
                            name="remember"
                            valuePropName="checked">
                            <Checkbox>保持登入</Checkbox>
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                登入
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Col>
        </div>
    );
}

export default AdminLoginPage;
